import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityBank } from "../../entity/EntityBank";

export class DtoBanksGetRes extends EntityBank {
  public items: EntityBank[]  = [];
}
